import axios from 'axios';

export default {
  openOverlay(state, overlayObject) {
    if (typeof overlayObject === 'string') state.currentOverlay = { overlayName: overlayObject, overlayData: null };
    else state.currentOverlay = overlayObject;
  },
  changeLocation(state, communeId) {
    state.communeSelected = communeId;
    state.communeSelectedInProcess = communeId;
  },
  setValidTickets(state, validTickets) {
    state.validTickets = validTickets;
  },
  // ticketBooking(state, ticketOrder) {
  //   console.log("Running Ticketbooking");
  //   ticketOrder.forEach(ticket => {
  //     if (ticket.ticketSavePerson) {
  //       const alreadySaved = state.savedUser.some(
  //         user => user.firstName === ticket.personFirstname && user.lastName === ticket.personLastname
  //       );
  //       if (!alreadySaved) {
  //         state.savedUser.push({
  //           ...(ticket.personFirstname && { firstName: ticket.personFirstname }),
  //           ...(ticket.personLastname && { lastName: ticket.personLastname }),
  //           ...(ticket.personSex && { sex: ticket.personSex }),
  //           ...(ticket.personBirthday && { birthday: ticket.personBirthday }),
  //           ...(ticket.personStreet && { street: ticket.personStreet }),
  //           ...(ticket.personZip && { zip: ticket.personZip }),
  //           ...(ticket.personResidence && { residence: ticket.personResidence }),
  //           ...(ticket.personPhone && { phone: ticket.personPhone }),
  //           ...(ticket.personMail && { mail: ticket.personMail }),
  //         });
  //       }
  //     }
  //   });

  //   state.ticketBooking = ticketOrder;
  // },
  communeSelectedInProcess(state, communeSelectedInProcess) {
    state.communeSelectedInProcess = communeSelectedInProcess;
  },
  setSavedUser(state, userlist) {
    state.savedUser = userlist;
  },
  setFavorites(state, favorites) {
    state.favorites = favorites || [];
  },
  updateCommunes(state, communes) {
    state.communes = communes;
  },
  updateCommuneInfo(state, communeInfo) {
    state.communeInfo = communeInfo;
  },
  updateTranslationsLoaded(state, translationsLoaded) {
    state.translationsLoaded = translationsLoaded;
  },
  updateBenefits(state, benefitData) {
    state.benefitCategories = benefitData.benefitCategories;
    state.benefits = benefitData.benefits;
  },
  updateManuallyDefinedSpecialConditions(state, manuallyDefinedSpecialConditions) {
    state.manuallyDefinedSpecialConditions = manuallyDefinedSpecialConditions;
  },
  voidBenefit(state, benefitId) {
    const benefitToBeVoided = state.benefits.find(b => b.id === benefitId);
    if (benefitToBeVoided) {
      benefitToBeVoided.benefitVoidingsCount += 1;
    } 
    else console.log('Error: No benefit found with ID', benefitId);
  },
  setPreferences(state, preferences) {
    state.preferences = preferences || [];
  },
  setLanguage(state, lang) {
    state.lang = lang;
    axios.defaults = { headers: { common: { 'accept-language': lang } } };
  },
  setUserTransactions(state, transactions) {
    state.userTransactions = transactions;
  },
  setApiInfo(state, version) {
    state.api = { version: version };
  },
};
